import { useNavigate } from "react-router-dom";
import { Package, Search } from "lucide-react";

type PostContextCardProps = {
  post: {
    $id: string;
    caption: string;
    imageUrl?: string | string[];
    isSellingPost?: boolean;
  };
};

const PostContextCard = ({ post }: PostContextCardProps) => {
  const navigate = useNavigate();

  // Get first image from imageUrl array
  const previewImage = Array.isArray(post.imageUrl)
    ? post.imageUrl[0]
    : post.imageUrl;

  return (
    <div
      onClick={() => navigate(`/posts/${post.$id}`)}
      className="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
    >
      {/* Deal About Label */}
      <div className="flex items-center px-3 pt-2.5 pb-1.5">
        <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
          Deal About
        </span>
      </div>

      {/* Post Preview */}
      <div className="flex px-3 pb-3">
        {previewImage ? (
          <img
            src={previewImage}
            alt="Post preview"
            className="w-14 h-14 rounded-lg object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-14 h-14 rounded-lg bg-gray-200 dark:bg-gray-600 flex items-center justify-center flex-shrink-0">
            <Package className="w-6 h-6 text-gray-400 dark:text-gray-500" />
          </div>
        )}

        <div className="ml-3 flex-1 min-w-0">
          <p className="font-semibold text-sm text-gray-900 dark:text-white line-clamp-2">
            {post.caption}
          </p>

          <div className="mt-1.5 flex items-center">
            {post.isSellingPost ? (
              <>
                <Package className="w-3.5 h-3.5 text-green-600 dark:text-green-400 mr-1" />
                <span className="text-xs font-medium text-green-600 dark:text-green-400">
                  Selling
                </span>
              </>
            ) : (
              <>
                <Search className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400 mr-1" />
                <span className="text-xs font-medium text-blue-600 dark:text-blue-400">
                  Looking for service
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Tap to view hint */}
      <div className="px-3 pb-2">
        <span className="text-xs text-gray-400 dark:text-gray-500 italic">
          Tap to view full details
        </span>
      </div>
    </div>
  );
};

export default PostContextCard;
